import type { IconData } from '@stacksjs/iconify-core'

export const sc4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0Z\"/><path fill=\"#d92223\" d=\"M0 480V0h640v160z\"/><path fill=\"#fcd955\" d=\"M0 480V0h426.7z\"/><path fill=\"#003d88\" d=\"M0 480V0h213.3z\"/><path fill=\"#007a39\" d=\"m0 480l640-160v160z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default sc4x3
